import { createSelector } from 'reselect'
import { State } from '../../store.types'

export const selectUser = (state: State) => state.user

export const selectUserEnvironmentDataList = createSelector(
  selectUser,
  (user) => {
    return (
      user.serverList.find((server) => server.serverPath === user.serverUrl)
        ?.environmentDataList ?? []
    )
  }
)
